import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.startsWith('./')) {
            return next.handle(req);
        }

        if (req.url.startsWith('http')) {
            return next.handle(req);
        }

        if (req.url.startsWith('/api/')) {
            return next.handle(req);
        }

        return next.handle(req.clone({
            url: '/api' + req.url
        }));
    }
}
